import { render, staticRenderFns } from "./AppointmentPriority.vue?vue&type=template&id=80b831c2&"
import script from "./AppointmentPriority.vue?vue&type=script&lang=js&"
export * from "./AppointmentPriority.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports